import ClientLog from './index.vue'; // 客户端日志

export default [
  {
    path: '/clientLog',
    name: 'clientLog',
    component: ClientLog,
    meta: {
      title: '客户端日志'
    },
  }
];



// WEBPACK FOOTER //
// ./src/views/ClientLog/router.js